import { Icon } from '@octano/global-ui';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { UncontrolledTooltip } from 'reactstrap';

import { EnrollmentTransferSummary } from '../../../types/studentStatusTypes';

import ModalTransferDetails from './ModalTransferDetails';

interface TransferTooltipButtonProps {
  transfer: EnrollmentTransferSummary;
  /** Used to make the tooltip target id unique within the table. */
  targetId: string;
}

const TransferTooltipButton = ({
  transfer,
  targetId,
}: TransferTooltipButtonProps) => {
  const prefix = 'studentStatus.transferTooltip';
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const empty = t(`${prefix}.emptyValue`);

  const lines: Array<[string, string]> = [
    [t(`${prefix}.field.type`), t(`${prefix}.type.${transfer.type}`)],
    [t(`${prefix}.field.sourcePlan`), transfer.sourceProgramName || empty],
    [
      t(`${prefix}.field.sourcePeriod`),
      transfer.sourceAdmissionPeriod || empty,
    ],
    [t(`${prefix}.field.currentPlan`), transfer.currentStudyPlanName || empty],
    [
      t(`${prefix}.field.transferPeriod`),
      transfer.currentTransferPeriod || empty,
    ],
  ];

  return (
    <>
      <button
        type="button"
        id={targetId}
        aria-label={t(`${prefix}.trigger`)}
        onClick={() => setOpen(true)}
        className="btn btn-link p-0 d-inline-flex align-items-center"
        style={{ lineHeight: 1 }}
      >
        <Icon name="information" size="20px" color="primary" />
      </button>
      <UncontrolledTooltip
        target={targetId}
        placement="bottom"
        className="transfer-tooltip"
        innerClassName="transfer-tooltip-inner"
      >
        <div className="text-left">
          <div className="font-weight-bold pb-2 fs-14 text-dark">
            {t(`${prefix}.modal.title`)}
          </div>
          {lines.map(([label, value]) => (
            <div key={label} className="text-dark fs-13">
              {label}: {value}
            </div>
          ))}
        </div>
      </UncontrolledTooltip>
      {open && (
        <ModalTransferDetails
          open={open}
          onClose={() => setOpen(false)}
          transfer={transfer}
        />
      )}
    </>
  );
};

export default TransferTooltipButton;
